import { motion } from "framer-motion";
import { Reveal, easeLux } from "../../lib/motion";
import { EXPERIENCES, IMAGES } from "../../lib/siteData";

export const Experiences = () => {
  return (
    <section
      id="sanctuary"
      data-testid="experiences-section"
      className="relative py-28 lg:py-40 bg-[#0F1012] text-[#F9F8F6]"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.4em] text-[#C5B498] mb-6">
            The Experiences
          </p>
          <h2 className="font-serif font-light tracking-tight leading-[1.02] text-[clamp(2rem,5.5vw,4.75rem)] max-w-4xl text-balance">
            Memory, presence, and meaning, held within consent.
          </h2>
          <p className="mt-6 max-w-2xl text-[#9A9C9F] leading-relaxed">
            Not a chatbot. Not a replacement for a person. EverSoul transforms approved
            memories, values, voice, imagery, and recorded guidance into spaces for
            reflection, remembrance, and carefully bounded presence. Every experience remains
            within the permissions established during life.
          </p>
        </Reveal>

        <div className="mt-20 border-t border-[#2A2C31]">
          {EXPERIENCES.map((e, i) => {
            const imageLeft = i % 2 === 1;
            return (
              <div
                key={e.k}
                data-testid={`experience-${i}`}
                className="group grid lg:grid-cols-2 gap-8 lg:gap-14 items-center border-b border-[#2A2C31] py-10 lg:py-14"
              >
                <Reveal className={imageLeft ? "lg:order-2" : "lg:order-1"}>
                  <div className="flex items-start gap-5">
                    <span className="font-serif font-light text-[#C5B498]/70 text-3xl leading-none shrink-0">
                      {`0${i + 1}`}
                    </span>
                    <div>
                      <div className="flex flex-wrap items-center gap-4 mb-4">
                        <h3 className="font-serif font-light text-[clamp(1.6rem,3.4vw,2.8rem)] tracking-tight">
                          {e.k}
                        </h3>
                        <span className="text-[10px] uppercase tracking-[0.3em] text-[#C5B498] border border-[#2A2C31] rounded-full px-3 py-1 whitespace-nowrap">
                          {e.tag}
                        </span>
                      </div>
                      <p className="text-[#9A9C9F] leading-relaxed max-w-lg">{e.body}</p>
                      {e.note && (
                        <p className="mt-4 font-serif italic text-[#e6e2d8] text-lg leading-snug max-w-lg">
                          {e.note}
                        </p>
                      )}
                    </div>
                  </div>
                </Reveal>

                <div className={`overflow-hidden rounded-sm ${imageLeft ? "lg:order-1" : "lg:order-2"}`}>
                  {e.imgAlt ? (
                    <div className={`relative w-full ${e.tall ? "h-[38vh] lg:h-[52vh]" : "h-[34vh] lg:h-[42vh]"}`}>
                      <img
                        src={IMAGES[e.img]}
                        alt={e.k}
                        className={`absolute inset-0 w-full h-full object-cover ${e.pos || "object-center"} grayscale-[0.25]`}
                      />
                      <motion.img
                        src={IMAGES[e.imgAlt]}
                        alt={e.k}
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: false, amount: 0.35 }}
                        transition={{ duration: 5, ease: "easeInOut" }}
                        className={`absolute inset-0 w-full h-full object-cover ${e.pos || "object-center"}`}
                      />
                    </div>
                  ) : (
                    <motion.img
                      src={IMAGES[e.img]}
                      alt={e.k}
                      initial={{ opacity: 0, scale: 1.08 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      viewport={{ once: true, margin: "-10%" }}
                      transition={{ duration: 1.2, ease: easeLux }}
                      className={`w-full ${e.tall ? "h-[38vh] lg:h-[52vh]" : "h-[34vh] lg:h-[42vh]"} object-cover ${e.pos || "object-center"} grayscale-[0.25] group-hover:grayscale-0 group-hover:scale-[1.03] transition-[filter,transform] duration-[900ms] ease-[cubic-bezier(0.25,1,0.5,1)]`}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
